export const ORDER_SET = 'ORDER_SET';
export const ORDER_UNSET = 'ORDER_UNSET';
export const ORDER_LOADING = 'ORDER_LOADING';
export const ORDER_LOADED = 'ORDER_LOADED';

